import { FC, HTMLAttributes, useState } from "react"

import { FieldError } from '../../../../../widgets'
import { ITimeProps } from './ITimeProps'
import clsx from 'clsx'
import { useTimeValidationSchema } from './TimeValidationSchema'

interface ISimpleTimeProps extends HTMLAttributes<HTMLInputElement>, ITimeProps { }

export const SimpleTime: FC<ISimpleTimeProps> = (props) => {
    const { id, placeholder, value: initValue, className, readOnly, disabled } = props;
    const schema = useTimeValidationSchema(props)
    const [error, setError] = useState<string>();
    const [value, setValue] = useState<string>(initValue || '');

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;
        setValue(inputValue)

        schema?.validate(inputValue)
            .then(() => setError(undefined))
            .catch((error) => setError(error.message))
    }

    return <>
        <input
            type='time'
            id={id}
            className={clsx(className, "form-control form-control-sm")}
            placeholder={placeholder}
            readOnly={readOnly}
            disabled={disabled}
            value={value}
            onChange={handleChange}
        />
        {error && <FieldError show={true} message={error} />}
    </>
}
